const Vue = require('vue')

const notificationsClient = require('../helpers/notifications-client')
const guid = require('../helpers/guid')

function defer () {
    return (() => {
        let resolve
        let reject

        const p = new Promise((res, rej) => {
            resolve = res
            reject = rej
        })

        return {
            promise: p,
            reject,
            resolve
        }
    })()
}

const worker = defer()

const bus = new Vue({
    methods: {
        status () {
            return this.$ask('are-you-alive', null, 10000).then((res) => {
                return !!res
            }).catch((ex) => {
                console.log({ ex })
                return false
            })
        }
    }
})

const localBus = new Vue()

const myNameIs = guid()

const oldEmit = bus.$emit
// const oldDispatch = bus.$dispatch
// const oldBroadcast = bus.$broadcast

bus.$dispatch = () => {
    throw new Error('Use $emit instead')
}

bus.$broadcast = () => {
    throw new Error('Use $emit instead')
}

const responses = {}

bus.$ask = function (eventId, content = undefined, timeout = 0) {
    return worker.promise.then((worker) => {
        return new Promise((resolve, reject) => {
            const requestId = guid()

            let timeoutId = null

            if (timeout > 0) {
                timeoutId = setTimeout(() => {
                    reject(new Error(`The timeout of ${timeout}ms expired`))
                }, timeout)
            }

            const deferred = defer()

            responses[requestId] = deferred

            deferred.promise.then((res) => {
                if (timeoutId) {
                    clearTimeout(timeoutId)
                }

                resolve(res)
            })

            worker.postMessage({
                type: eventId,
                content,
                requestId,
                asking: true
            })
        })
    })
}

bus.$emit = function (eventId, content = undefined) {
    return worker.promise.then((worker) => {
        worker.postMessage({
            type: eventId,
            content
        })
    })
}

localBus.$on('service-worker-registered', (reg) => {
    const user = document.SCI_DATA['user']
    const token = window['__sessionToken']

    if (!user) {
        return
    }

    const key = `sci:push-registration:${token}`

    let pushRegistration = null

    try {
        if (localStorage.getItem(key)) {
            pushRegistration = JSON.parse(localStorage.getItem(key))
        }
    } catch (ex) {
        pushRegistration = null
        localStorage.removeItem(key)
    }

    reg.pushManager.subscribe({
        // veja app/VAPID.txt
        applicationServerKey: urlBase64ToUint8Array('BPErUqcjVHfrrV_KOnWMQIU0JD0iXQOi1w9NOsAp-oTYq-9wQE14R6LzvsCVQWCIPYnd5lgxvNRms3XqlXsa_X0'),
        userVisibleOnly: true
    }).then((pushReg) => {
        if (pushRegistration && pushReg.endpoint === pushRegistration.endpoint) {
            return {
                data: pushRegistration
            }
        }

        // necessário porque o superagent envia o objeto com toString,
        // e se mandar String ele envia como application/x-www-form-urlencoded :)
        pushReg = pushReg.toJSON()

        return notificationsClient.mutate(
            {
                mutation: `
                    mutation($params: WebpushListenerParamsInput!, $expiresAt: LocalDateTime) {
                      registerWebpushListener(params: $params, expiresAt: $expiresAt) {
                        id
                      }
                    }
                `,
                variables: {
                    params: {
                        endpoint: pushReg.endpoint,
                        auth: pushReg.keys.auth,
                        p256dh: pushReg.keys.p256dh
                    },
                    expiresAt: pushReg.expirationTime ? moment(pushReg.expirationTime) : null,
                }
            }
        )
    }).then((res) => {
        localStorage.setItem(key, JSON.stringify(res.data))
    }).catch((err) => {
        console.warn('Notifications not allowed, unable to register.')
    })
})

if (
    'serviceWorker' in navigator &&
    window.location.protocol === 'https:' &&
    window.SESSION_DATA
) {
    // Handler for messages coming from the service worker
    navigator.serviceWorker.addEventListener('message', function (e) {
        if (e.data && e.data.__ok) {
            const data = e.data

            switch (data.type) {
                case 'event':
                    const {
                        eventName, eventData, source
                    } = data.content
                    if (source === myNameIs) {
                        return
                    }

                    bus.$emit(eventName, eventData, true)
                    break
                case 'reply':
                    const {
                        inReplyTo
                    } = data

                    if (responses[inReplyTo]) {
                        responses[inReplyTo].resolve(data.content)
                    }
                    break
            }
        }
    })

    navigator.serviceWorker.ready
        .then((reg) => {
            if (!reg.active) {
                return
            }

            worker.resolve(reg.active)

            localBus.$emit('service-worker-registered', reg)
        })
        .catch((x) => {
            console.error(x)
        })

    navigator.serviceWorker.register('/service-worker.js', {
        scope: '/'
    })
}

window.__serviceWorker = bus

module.exports = bus

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/')

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/std/service-worker.js